// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"58e04704","453":"dff87da4"}[chunkId] + ".chunk.js";
};